export default __webpack_public_path__ + "static/media/Lora-Italic.8700ca09.ttf";